// ** React Imports
import { useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Alert from '@mui/material/Alert'
import Select from '@mui/material/Select'
import { styled } from '@mui/material/styles'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel'
import AlertTitle from '@mui/material/AlertTitle'
import IconButton from '@mui/material/IconButton'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import Button from '@mui/material/Button'

// ** Icons Imports
import CloseIcon from '@mui/icons-material/Close';

const ImgStyled = styled('img')(({ theme }) => ({
  width: 120,
  height: 120,
  marginRight: theme.spacing(6.25),
  borderRadius: theme.shape.borderRadius
}))

const ButtonStyled = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    textAlign: 'center'
  }
}))

const ResetButtonStyled = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(4.5),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: 0,
    textAlign: 'center',
    marginTop: theme.spacing(4)
  }
}))

const TabInfo = () => {
  // ** State
  const [openAlert, setOpenAlert] = useState(true)
  const [imgSrc, setImgSrc] = useState('data:image/png;base64,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')

  const onChange = file => {
    const reader = new FileReader()
    const { files } = file.target
    if (files && files.length !== 0) {
      reader.onload = () => setImgSrc(reader.result)
      reader.readAsDataURL(files[0])
    }
  }

  return (
    <CardContent>
      <form>
        <Grid container spacing={7}>
          <Grid item xs={12} sx={{ marginTop: 4.8, marginBottom: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ImgStyled src={imgSrc} alt='Profile Pic' />
              <Box>
                <ButtonStyled component='label' variant='contained' htmlFor='account-settings-upload-image'>
                  Upload New Photo
                  <input
                    hidden
                    type='file'
                    onChange={onChange}
                    accept='image/png, image/jpeg'
                    id='account-settings-upload-image'
                  />
                </ButtonStyled>
                <ResetButtonStyled color='error' variant='outlined' onClick={() => setImgSrc('/images/avatars/1.png')}>
                  Reset
                </ResetButtonStyled>
                <Typography variant='body2' sx={{ marginTop: 5 }}>
                  Allowed PNG or JPEG. Max size of 800K.
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField fullWidth label='First Name' placeholder='johnDoe' defaultValue='johnDoe' />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label=' Last Name' placeholder='John Doe' defaultValue='John Doe' />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type='email'
              label='Email'
              placeholder='johnDoe@example.com'
              defaultValue='johnDoe@example.com'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Test Expertise</InputLabel>
              <Select label='Test Expertise' defaultValue='admin'>
                <MenuItem value='admin'>Admin</MenuItem>
                <MenuItem value='author'>Author</MenuItem>
                <MenuItem value='editor'>Editor</MenuItem>
                <MenuItem value='maintainer'>Maintainer</MenuItem>
                <MenuItem value='subscriber'>Subscriber</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Contact</InputLabel>
              <Select label='Status' defaultValue='active'>
                <MenuItem value='active'>Active</MenuItem>
                <MenuItem value='inactive'>Inactive</MenuItem>
                <MenuItem value='pending'>Pending</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField fullWidth label='Whatsapp number' placeholder='ABC Pvt. Ltd.' defaultValue='ABC Pvt. Ltd.' />
          </Grid>

          {openAlert ? (
            <Grid item xs={12} sx={{ mb: 3 }}>
              <Alert
                severity='warning'
                sx={{ '& a': { fontWeight: 400 } }}
                action={
                  <IconButton size='small' color='inherit' aria-label='close' onClick={() => setOpenAlert(false)}>
                    <CloseIcon fontSize='inherit' />
                  </IconButton>
                }
              >
                <AlertTitle>Your email is not confirmed. Please check your inbox.</AlertTitle>
                <Link href='/' onClick={e => e.preventDefault()}>
                  Resend Confirmation
                </Link>
              </Alert>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <Button variant='contained' sx={{ marginRight: 3.5 }}>
              Save Changes
            </Button>
            <Button type='reset' variant='outlined' color='secondary'>
              Reset
            </Button>
          </Grid>
        </Grid>
      </form>
    </CardContent>
  )
}

export default TabInfo